<!--
 * @FileDescription: 异常订单列表
 * @Author: 陈文景
 * @Date: 2022-11-14 09:07:37
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <PageSkeletonTwo>
    <template slot="header-left">
      <el-select v-model="parameter.platformCode" size="medium" placeholder="选择平台" @change="selectPlatform" style="width:130px;">
        <el-option v-for="item in platformOptions" :key="item.platformCode" :disabled="item.platformCode === 'KA'" :label="item.platformName" :value="item.platformCode" />
      </el-select>

      <el-select v-model="parameter.storeIds" multiple collapse-tags filterable clearable size="medium" placeholder="选择店铺" @change="getAnomalousOrderList">
        <el-option v-for="item in storeOptions" :key="item.storeId" :label="item.storeName" :value="item.storeId" />
      </el-select>

      <el-select v-model="parameter.userIds" size="medium" clearable multiple collapse-tags filterable remote reserve-keyword placeholder="邮箱/手机号" :remote-method="remoteMethod" :loading="userLoading" @change="getAnomalousOrderList">
        <!-- <el-option v-for="item in userOptions" :key="item.userId" :label="item.email" :value="item.userId" /> -->
        <el-option v-for="item in userOptions" :key="item.userId" :label="`${item.email||''}${(item.email&&item.phone?' / ':'')}${item.phone||''}`" :value="item.userId" :title="`${item.email||''}${item.phone?' / '+item.phone:''}`" />
      </el-select>

      <el-select v-model="parameter.state" clearable size="medium" placeholder="选择状态" style="width:110px;" @change="getAnomalousOrderList">
        <el-option v-for="item in stateOptions" :key="item.id" :label="item.label" :value="item.value" />
      </el-select>

      <div class="select-picker">
        <el-select v-model="parameter.date" size="medium" placeholder="请选择" style="width:100px;">
          <el-option label="抓单时间" :value="1" />
        </el-select>
        <el-date-picker v-model="parameter.time" size="medium" type="datetimerange" style="width:360px;" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="changeDatePicker" />
      </div>

      <div class="batch-search">
        <BatchSearchOne placeholder="请输入订单号(支持批量搜索)" @clear="handleClearBatchSearchOne" @search="handleSearchBatchSearchOne" />
      </div>

      <el-button size="medium" style="width:120px;" :disabled="!selection.length" @click="handleBatchRebuild(1)">批量重新生成</el-button>
      <el-button size="medium" style="width:120px;" :disabled="!selection.length" @click="handleBatchRebuild(2)">批量标记处理</el-button>
      <el-button size="medium" style="width:120px;" :disabled="!anomalous.length" class="last-child" @click="handleExport">数据导出</el-button>
    </template>

    <template slot="container">
      <el-table ref="multipleTable" :data="anomalous" v-loading="loading" row-key="id" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" fixed="left" width="55" />
        <el-table-column label="平台" fixed="left" width="220">
          <template v-slot="{ row }">
            <span>{{ `${defaultTips(row.storeName)} - ${defaultTips(row.platformName)}` }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单ID" width="220">
          <template v-slot="{ row }">
            <span>{{ defaultTips(row.orderId) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="付款时间" width="280">
          <template v-slot="{ row }">
            <p>抓单时间：{{ defaultTips(formatTimeStamp(row.createDate)) }}</p>
            <p>下单时间：{{ defaultTips(formatTimeStamp(row.purchaseDate)) }}</p>
            <p>付款时间：{{ defaultTips(formatTimeStamp(row.payDate)) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="总金额（含税）" width="150">
          <template v-slot="{ row }">
            <span>{{ `USD ${defaultTips(row.totalAmount)}` }}</span>
          </template>
        </el-table-column>
        <el-table-column label="处理状态" width="140">
          <template v-slot="{ row }">
            <span>{{ handleState(row.state) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Kaka邮箱/手机号" width="240">
          <template v-slot="{ row }">
            <span>{{ defaultTips(row.showName) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="错误原因">
          <template v-slot="{ row }">
            <span>{{ defaultTips(row.causesFailure) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template v-slot="{ row }">
            <a href="javascript:;" @click="() => handleOrderDetails(row.id)">订单详情</a>
            <template v-if="row.state !== 1">
              <span class="vertical ">|</span>
              <el-dropdown size="medium" placement="bottom" @command="(value) => handleDropdown(row.id, value)">
                <span class="el-dropdown-link">
                  <span>更多</span>
                  <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown" class="more-dropdown">
                  <el-dropdown-item :command="1">重新生成</el-dropdown-item>
                  <el-dropdown-item :command="2">标记处理</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template #footer-right>
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </template>
  </PageSkeletonTwo>
</template>

<script>
import API from '@/api'
import cloneDeep from 'lodash/cloneDeep'
import { formatTimeStamp } from '@/utils/moment.js'
import BatchSearchOne from '@/components/BatchSearchOne.vue'
import PageSkeletonTwo from '@/components/PageSkeletonTwo.vue'

let parameter = {
  platformCode: undefined, // 平台简码
  storeIds: [], // 店铺ID
  userIds: [], // 用户ID
  time: undefined, // 时间（请求接口前删除该字段）
  date: 1, // 时间类型（请求接口前删除该字段）
  startDate: undefined, // 开始时间
  endDate: undefined, // 结束时间
  texts: [], // 批量搜索
  state: 0, // 处理状态：0.未处理 1.已处理
  pageSize: 20,
  pageNumber: 1
}

export default {
  name: 'orders_anomalous',
  components: {
    BatchSearchOne,
    PageSkeletonTwo
  },
  data() {
    return {
      formatTimeStamp,

      platformOptions: [], // 平台下拉选项
      storeOptions: [], // 店铺下拉选项

      // 店铺下拉选项
      stateOptions: [
        { id: 1, label: '未处理', value: 0 },
        { id: 2, label: '已处理', value: 1 }
      ],

      userOptions: [], // 用户邮箱下拉选项
      userLoading: false,

      total: 0,
      loading: false,
      anomalous: [],
      parameter: { ...parameter },

      // 查询用户列表的请求参数
      userParameter: {
        email: undefined, // 查询关键字
        pageNumber: 1,
        pageSize: 20,
        users: []
      },

      selection: [] // 表格当前选中行的ID数组
    }
  },
  created() {
    this.getUserOptions()
    this.getPlatformSelect()
  },
  activated() {
    this.getPlatformSelect()
  },
  computed: {
    handleState() {
      return (state) => {
        switch (state) {
          case 0:
            return '未处理'
          case 1:
            return '已处理'
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * API 获取异常订单列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getAnomalousOrderList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let query = { ...this.parameter }
        delete query.time
        delete query.date
        let { data } = await API.getAnomalousOrderList(query)
        this.total = data.total
        this.anomalous = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * API 获取平台下拉选项
     */
    async getPlatformSelect() {
      let { data } = await API.getPlatformSelect({ status: 0 })
      if (data.length) {
        this.platformOptions = data.filter((item) => item.platformCode !== 'KA')
        if (!this.parameter.platformCode) {
          this.parameter.platformCode = this.platformOptions[0].platformCode
        }
        this.getStoreSelect(this.platformOptions[0].platformCode)
      }
      this.getAnomalousOrderList()
    },

    /**
     * API 获取店铺下拉选项
     *
     * @param {String} platformCode 平台编码
     */
    async getStoreSelect(platformCode) {
      let { data } = await API.getStoreSelect({ platformCode: platformCode, userId: this.$store.getters.userId, storeStatus: 1, authorizeStatus: 1, storeGroup: 100 })
      this.storeOptions = data
    },

    /**
     * API 获取用户列表
     */
    async getUserOptions() {
      try {
        this.userLoading = true
        let { data } = await API.getUserOptions(this.userParameter)
        this.userOptions = data.list
      } catch (error) {
        throw new Error(error.message)
      } finally {
        this.userLoading = false
      }
    },

    /**
     * API 重新生成或标记处理
     *
     * @param {Object} payload 参数对象
     */
    async generateFromNew(payload) {
      let { code, message } = await API.generateFromNew(payload)
      this.$message({
        type: code === 10000 ? 'success' : 'error',
        message
      })
      this.getAnomalousOrderList()
    },

    /**
     * API 导出异常订单列表
     */
    async importExportFile() {
      let parameter = cloneDeep(this.parameter)
      parameter.ids = this.selection.map((row) => row.id).filter(Boolean)
      let { code, message } = await API.importExportFile({
        condition: JSON.stringify(parameter),
        fileType: 2,
        taskType: 17
      })
      if (code === 10000) {
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * 选择平台
     *
     * @param {Number} value 目前的选中值（平台Code）
     */
    selectPlatform(value) {
      if (value) {
        this.getStoreSelect(value)
      } else {
        this.storeOptions = []
        this.parameter.storeIds = []
      }
      this.getAnomalousOrderList()
    },

    /**
     * 时间日期选择器的回调事件
     *
     * @param {Array} date 日期数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        this.parameter.startDate = date[0]
        this.parameter.endDate = date[1]
      } else {
        this.parameter.startDate = null
        this.parameter.endDate = null
      }
      this.getAnomalousOrderList()
    },

    /**
     * 批量搜索清除内容的回调事件
     */
    handleClearBatchSearchOne() {
      this.parameter.texts = []
      this.getAnomalousOrderList()
    },

    /**
     * 批量搜索的回调事件
     *
     * @param {String} value 搜索关键字
     */
    handleSearchBatchSearchOne(value) {
      if (value !== undefined) {
        this.parameter.texts = value.split(',')
      }
      this.getAnomalousOrderList()
    },

    /**
     * 用户邮箱远程搜索
     *
     * @param {String} query 搜索关键字
     */
    remoteMethod(query) {
      if (query) {
        this.userParameter.email = query
      } else {
        this.userParameter.email = undefined
      }
      this.userParameter.email = this.userParameter.email.trim()
      this.getUserOptions()
    },

    /**
     * 批量重新生成
     */
    handleBatchRebuild(type) {
      this.$confirm(type === 1 ? '是否批量重新生成订单？' : '是否批量标记处理？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.generateFromNew({ ids: this.selection.map((row) => row.id).filter(Boolean), platformCode: this.parameter.platformCode, type: type })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: type === 1 ? '已取消批量重新生成订单!' : '已取消批量标记处理!'
          })
        })
    },

    /**
     * 数据导出
     */
    handleExport() {
      var tip = '导出当前选中的数据，是否继续?'
      if (!this.selection.length){
        tip = '此操作将导出所有异常订单, 是否继续?'
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.importExportFile()
        })
        .catch(() => {
          this.$message.info('已取消导出')
        })
    },

    /**
     * 当选择项发生变化时会触发该事件
     *
     * @param {Array} selection 选中的行对象数组
     */
    handleSelectionChange(selection) {
      this.selection = selection
    },

    /**
     * 异常订单详情
     *
     * @param {Object} id 当前点击的行的ID
     */
    handleOrderDetails(id) {
      this.$router.push({
        path: '/orders/anomalous/anomalous-details',
        query: { id, platformCode: this.parameter.platformCode }
      })
    },

    /**
     * 更多按钮
     *
     * @param {Number} id 当前点击的行的ID
     * @param {Number} value 当前点击的下拉项
     */
    handleDropdown(id, value) {
      this.$confirm(value === 1 ? '是否重新生成订单？' : value === 2 ? '是否标记订单已处理？' : '-', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (value === 1) {
            this.generateFromNew({ ids: [id], platformCode: this.parameter.platformCode, type: 1 })
          }
          if (value === 2) {
            this.generateFromNew({ ids: [id], platformCode: this.parameter.platformCode, type: 2 })
          }
          this.getAnomalousOrderList(false)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: value === 1 ? '已取消重新生成订单!' : value === 2 ? '已取消标记订单!' : '-'
          })
        })
    },

    /**
     * 每页显示数量发生改变时的回调
     *
     * @param size 每页显示数量
     */
     handleSizeChange(size) {
      this.parameter.pageSize = size
      this.getAnomalousOrderList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param current 当前页
     */
     handleCurrentChange(current) {
      this.parameter.pageNumber = current
      this.getAnomalousOrderList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.common-footer {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
}
.select-picker {
  display: inline-block;
  .el-select {
    width: 108px;
    /deep/.el-input__inner {
      border-right: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .el-range-editor.el-input__inner {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}

.batch-search {
  display: inline-block;
  /deep/.el-input__inner {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  /deep/.el-input-group__append {
    color: #909399;
    background-color: #f5f7fa;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.el-select {
  width: 168px;
}

.el-button {
  margin: 0;
  &.last-child {
    margin-right: 0 !important;
  }
}

a {
  color: #99c41c;
  text-decoration: none;
  outline: none;
}

.vertical {
  color: #f5f7f7;
  margin: 0 5px;
}

.el-dropdown-link {
  color: #99c41c;
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-carousel__item {
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
}

.more-dropdown {
  width: 100px;
}
</style>
